import { atom } from 'recoil';

import {
  PrivatePensionAccountHolder,
  PrivatePensionBeneficiary,
  PrivatePensionKind,
  PrivatePensionPaymentMethod,
  PrivatePensionPortabilityInfo,
  PrivatePensionTaxSystem,
} from '../../../pages/BatchTicket/components/DynamicAsset/hooks/products/PrivatePension/types';
import {
  PrivatePensionClientBankAccountEntityNormalized,
  PrivatePensionEntityNormalized,
} from '../types';

export const privatePensionLoadedState = atom({
  key: 'privatePensionLoadedState',
  default: { data: [] as PrivatePensionEntityNormalized[], loaded: false, meta: {} as any },
});

export const privatePensionProductsLoadedState = atom({
  key: 'privatePensionProductsLoadedState',
  default: { data: [] as PrivatePensionEntityNormalized[], loaded: false, meta: {} as any },
});

export const privatePensionOrderState = atom<{
  kind: PrivatePensionKind;
  bankAccounts: (PrivatePensionClientBankAccountEntityNormalized & { manuallyAdded?: boolean })[];
  portabilities: PrivatePensionPortabilityInfo[];
  accountHolder: PrivatePensionAccountHolder | null;
  pensionAge: number;
  paymentMethod: PrivatePensionPaymentMethod;
  taxSystem: PrivatePensionTaxSystem;
  dueDate: number | undefined;
  bankAccountId: number | undefined;
  singleContribution: number | undefined;
  monthlyContribution: number | undefined;
  beneficiaries: PrivatePensionBeneficiary[];
}>({
  key: 'privatePensionOrderState',
  default: {
    kind: PrivatePensionKind.PGBL,
    bankAccounts: [],
    portabilities: [],
    accountHolder: null,
    pensionAge: 0,
    paymentMethod: PrivatePensionPaymentMethod.Debit,
    taxSystem: PrivatePensionTaxSystem.Progressive,
    dueDate: undefined,
    bankAccountId: undefined,
    singleContribution: undefined,
    monthlyContribution: undefined,
    beneficiaries: [],
  },
});
